/** Google Analytics 4 measurement id (public by design: it ships in every page). */
export const TRACKING_ID = "G-8D55E08CSF";
